module.exports = __webpack_public_path__ + "static/img/xiafaPro.5af468c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/xiafaPro.png
// module id = ohvg
// module chunks = 1